import { isAfter, isBefore } from 'date-fns';
import { HabitSchedule } from 'shared/types/habit-schedule';
import { Timestamp } from 'shared/types/timestamp';

import { getActiveSchedule } from '../get-active-schedule';
import { getActualScheduleStartDate } from './get-actual-schedule-start-date';
import { getScheduleEndDate } from './get-schedule-end-date';

export const getScheduleByDate = (
  schedules: HabitSchedule[] | undefined | null,
  date: Timestamp,
) =>
  schedules?.length === 1
    ? schedules[0]
    : schedules?.find((schedule) => {
        const scheduleStartDate = getActualScheduleStartDate(schedule);
        return (
          isAfter(date, scheduleStartDate) &&
          (!schedule.endDate || isBefore(date, getScheduleEndDate(schedule)!))
        );
      }) ?? getActiveSchedule(schedules);
